import type { IntegralCoverage } from "./integralCoverage";
import type {
  BenchInput,
  PreApprovedScreening,
  QuoteRow,
  SubmitPayload,
} from "./types";

// Items follow the server's list order, so one selection is one payload and
// the idempotency key can be matched to it.
export const buildSubmitPayload = (input: {
  bench: BenchInput;
  screenings: PreApprovedScreening[];
  selected: ReadonlySet<string>;
  // One for the whole batch: the highest the merchant declared.
  integralCoverage: IntegralCoverage;
  // The numbers on screen at Resumen; the server compares them.
  quoted: Pick<QuoteRow, "pct" | "rateWithVat" | "monthlyCost">;
}): SubmitPayload => ({
  bench: input.bench,
  pct: input.quoted.pct,
  items: input.screenings
    .filter((screening) => input.selected.has(screening.screeningId))
    .map((screening) => ({
      screeningId: screening.screeningId,
      integralAmount: input.integralCoverage,
    })),
  quotedRate: input.quoted.rateWithVat,
  quotedMonthlyCost: input.quoted.monthlyCost,
  acknowledgments: { accuracyDeclaration: true },
});
